
(function(){
  var root=document.getElementById('ProtocolWriter'); if(!root)return;
  var key='arcademie_protocol_writer_v2';
  var state={step:0,data:{},variables:[],pubmed:[]};
  try{var saved=localStorage.getItem(key);if(saved)state=Object.assign(state,JSON.parse(saved)||{});}catch(e){}
  state.data=state.data||{}; state.variables=state.variables||[]; state.pubmed=state.pubmed||[];

  var fields=[].slice.call(root.querySelectorAll('[data-key]'));
  fields.forEach(function(el){
    var k=el.dataset.key;if(state.data[k]!=null)el.value=state.data[k];
    ['input','change'].forEach(function(ev){el.addEventListener(ev,function(){state.data[k]=el.value;save();});});
  });

  var stepBtns=[].slice.call(document.querySelectorAll('#ProtocolSteps [data-step]'));
  var panels=[].slice.call(document.querySelectorAll('.pr-panel'));
  var prev=document.getElementById('PrevStep'),next=document.getElementById('NextStep');
  function showStep(n){
    state.step=Math.max(0,Math.min(9,n)); stepBtns.forEach(b=>b.classList.toggle('active',+b.dataset.step===state.step));
    panels.forEach(p=>p.classList.toggle('active',+p.dataset.panel===state.step));
    prev.style.visibility=state.step===0?'hidden':'visible'; next.style.display=state.step===9?'none':'inline-flex';
    if(state.step===9)renderPreview(); save();
    root.scrollIntoView({behavior:'smooth',block:'start'});
  }
  stepBtns.forEach(b=>b.addEventListener('click',()=>showStep(+b.dataset.step)));
  prev.addEventListener('click',()=>showStep(state.step-1)); next.addEventListener('click',()=>showStep(state.step+1));
  function save(){try{localStorage.setItem(key,JSON.stringify(state));}catch(e){}}
  function val(k){return (state.data[k]||'').trim()}
  function esc(s){return (s||'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]))}
  function selectedRefs(){return state.pubmed.filter(x=>x.selected);}
  function refsText(){return selectedRefs().map(x=>x.citation).join('\n') || val('references');}

  // Variables
  function renderVariables(){
    var box=document.getElementById('VariableTable');
    if(!state.variables.length){box.innerHTML='<p class="pr-help">Aucune variable ajoutée.</p>';return;}
    box.innerHTML='<div class="pr-var-row header"><span>Variable</span><span>Type</span><span>Unité</span><span>Moment</span><span>Rôle</span><span></span></div>'+
      state.variables.map((v,i)=>'<div class="pr-var-row"><span>'+esc(v.name)+'</span><span>'+esc(v.type)+'</span><span>'+esc(v.unit)+'</span><span>'+esc(v.time)+'</span><span>'+esc(v.role)+'</span><button type="button" data-rmvar="'+i+'">×</button></div>').join('');
    box.querySelectorAll('[data-rmvar]').forEach(b=>b.addEventListener('click',()=>{state.variables.splice(+b.dataset.rmvar,1);save();renderVariables();}));
  }
  document.getElementById('AddVariable').addEventListener('click',function(){
    var name=document.getElementById('VarName').value.trim(); if(!name)return;
    state.variables.push({name,type:document.getElementById('VarType').value,unit:document.getElementById('VarUnit').value,time:document.getElementById('VarTime').value,role:document.getElementById('VarRole').value});
    ['VarName','VarUnit','VarTime'].forEach(id=>document.getElementById(id).value=''); save(); renderVariables();
  });
  renderVariables();

  // PubMed
  document.getElementById('UseProjectAsQuery').addEventListener('click',function(){
    var source=(val('projectQuestion')+' '+val('title')).trim();
    var stop=new Set(('le la les un une des du de d dans sur pour avec sans et ou au aux en chez entre par est sont etre être étude etude recherche clinique patient patients projet effet impact évaluer evaluer comparaison comparer mesurer analyse analyser objectif principale principal secondaire chez this that with from into study studies clinical research patient patients effect impact evaluate evaluation comparison').split(/\s+/));
    var words=source.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'')
      .replace(/[^a-z0-9\-\s]/g,' ').split(/\s+/)
      .filter(function(w){return w.length>=4&&!stop.has(w)&&!/^\d+$/.test(w);});
    var uniq=[];
    words.forEach(function(w){if(uniq.indexOf(w)===-1&&uniq.length<6)uniq.push(w);});
    if(uniq.length<2){
      document.getElementById('PubmedStatus').textContent='Le projet est trop court ou trop vague. Saisissez au moins 2 mots-clés scientifiques précis.';
      return;
    }
    var q=uniq.join(' AND ');
    document.getElementById('PubmedQuery').value=q; state.data.pubmedQuery=q;save();
    document.getElementById('PubmedStatus').textContent='Mots-clés extraits : '+q+'. Vérifiez-les avant de lancer la recherche.';
  });
  async function pubmedSearch(){
    var status=document.getElementById('PubmedStatus'),box=document.getElementById('PubmedResults');
    var query=document.getElementById('PubmedQuery').value.trim();
    if(!query){status.textContent='Saisissez des mots-clés scientifiques.';return;}
    var plain=query.replace(/\b(AND|OR|NOT)\b/gi,' ').replace(/\[[^\]]+\]/g,' ').trim();
    var meaningful=plain.split(/\s+/).filter(function(w){return w.replace(/[^A-Za-z0-9-]/g,'').length>=3;});
    if(meaningful.length<2){
      status.textContent='Requête trop vague : ajoutez au moins 2 concepts scientifiques précis.';
      return;
    }
    var start=document.getElementById('PubmedStart').value.trim(),end=document.getElementById('PubmedEnd').value.trim();
    var advanced=/\b(AND|OR|NOT)\b|\[[^\]]+\]/i.test(query);
    var term;
    if(advanced){
      term=query;
    }else{
      var concepts=query.split(/[;,]+|\s{2,}/).map(function(x){return x.trim();}).filter(Boolean);
      if(concepts.length===1) concepts=query.split(/\s+/).filter(Boolean);
      concepts=concepts.slice(0,6);
      term=concepts.map(function(x){return '"'+x.replace(/"/g,'')+'"[Title/Abstract]';}).join(' AND ');
    }
    if(start||end) term+=' AND '+(start||'1900')+':'+(end||new Date().getFullYear())+'[dp]';
    status.textContent='Recherche PubMed en cours…';box.innerHTML='';
    try{
      var s=await fetch('https://eutils.ncbi.nlm.nih.gov/entrez/eutils/esearch.fcgi?db=pubmed&retmode=json&retmax=10&sort=relevance&term='+encodeURIComponent(term));
      var sj=await s.json(); var ids=(sj.esearchresult&&sj.esearchresult.idlist)||[];
      if(!ids.length){status.textContent='Aucun article trouvé.';state.pubmed=[];save();return;}
      var sum=await fetch('https://eutils.ncbi.nlm.nih.gov/entrez/eutils/esummary.fcgi?db=pubmed&retmode=json&id='+ids.join(','));
      var sumj=await sum.json();
      var fx=await fetch('https://eutils.ncbi.nlm.nih.gov/entrez/eutils/efetch.fcgi?db=pubmed&retmode=xml&id='+ids.join(','));
      var xml=new DOMParser().parseFromString(await fx.text(),'text/xml');
      state.pubmed=ids.map(function(id){
        var r=sumj.result[id]||{}; var node=[...xml.querySelectorAll('PubmedArticle')].find(n=>(n.querySelector('PMID')||{}).textContent===id);
        var abstract=node?[...node.querySelectorAll('AbstractText')].map(x=>x.textContent).join(' '):'';
        var authors=(r.authors||[]).slice(0,5).map(a=>a.name).join(', ');
        var year=(r.pubdate||'').slice(0,4); var journal=r.fulljournalname||r.source||'';
        return {pmid:id,title:r.title||'',authors,year,journal,abstract,selected:false,citation:(authors?authors+'. ':'')+(r.title||'')+'. '+journal+(year?' ('+year+')':'')+'. PMID: '+id};
      }); save(); renderPubmed(); status.textContent=state.pubmed.length+' article(s) trouvé(s). Sélectionnez les références pertinentes.';
    }catch(e){status.textContent='La recherche PubMed n’a pas pu être chargée depuis ce navigateur. Réessayez ou saisissez les références manuellement.';}
  }
  function renderPubmed(){
    var box=document.getElementById('PubmedResults');
    box.innerHTML=state.pubmed.map((a,i)=>'<label class="pr-pubmed-result"><input type="checkbox" data-pubsel="'+i+'" '+(a.selected?'checked':'')+'><span><b>'+esc(a.title)+'</b><small>'+esc([a.authors,a.journal,a.year,'PMID '+a.pmid].filter(Boolean).join(' · '))+'</small>'+(a.abstract?'<p>'+esc(a.abstract.slice(0,800))+(a.abstract.length>800?'…':'')+'</p>':'<p>Abstract non disponible via PubMed.</p>')+'<a href="https://pubmed.ncbi.nlm.nih.gov/'+a.pmid+'/" target="_blank" rel="noopener">Voir sur PubMed →</a></span></label>').join('');
    box.querySelectorAll('[data-pubsel]').forEach(cb=>cb.addEventListener('change',function(){state.pubmed[+cb.dataset.pubsel].selected=cb.checked;state.data.references=refsText();var f=root.querySelector('[data-key="references"]');if(f)f.value=state.data.references;save();}));
  }
  document.getElementById('PubmedSearch').addEventListener('click',pubmedSearch);
  renderPubmed();

  document.getElementById('AISynthesis').addEventListener('click',async function(){
    var btn=this;
    var sel=selectedRefs().filter(function(a){return (a.abstract||'').trim().length>80;});
    var area=root.querySelector('[data-key="literatureSynthesis"]');
    var question=val('projectQuestion');
    if(question.length<25){
      alert('Décrivez d’abord la question du projet avec au moins une phrase complète et précise.');
      return;
    }
    if(sel.length<2){
      alert('Sélectionnez au moins 2 articles PubMed avec abstract pour produire une synthèse fiable.');
      return;
    }

    var original=btn.textContent;
    btn.disabled=true;
    btn.textContent='Synthèse IA en cours…';
    area.value='Génération de la synthèse bibliographique par IA…';

    try{
      var payload={
        question:question,
        articles:sel.map(function(a){
          return {
            pmid:String(a.pmid||''),
            title:String(a.title||''),
            abstract:String(a.abstract||'').slice(0,5000),
            citation:String(a.citation||'')
          };
        })
      };
      var response=await fetch('https://arcademie-ai-api-ogaq-production.up.railway.app/api/literature-synthesis',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify(payload)
      });
      var data=await response.json().catch(function(){return {};});
      if(!response.ok||!data.synthesis) throw new Error(data.error||'Erreur du service IA');
      area.value=data.synthesis;
      state.data.literatureSynthesis=data.synthesis;
      save();
    }catch(err){
      area.value='';
      alert('La synthèse IA est temporairement indisponible. Vérifiez que le service Arcademie-AI est bien déployé sur Railway puis réessayez.');
    }finally{
      btn.disabled=false;
      btn.textContent=original;
    }
  });

  function variablesText(){
    if(!state.variables.length)return val('variablesNotes');
    return state.variables.map(v=>v.name+' | '+v.type+' | '+(v.unit||'-')+' | '+(v.time||'-')+' | '+v.role).join('\n')+(val('variablesNotes')?'\n'+val('variablesNotes'):'');
  }
  function protocolSections(){
    return [
      ['1. Informations générales et organisation de l’étude',[
        ['Titre de l’étude',val('title')],['Acronyme',val('acronym')],['Promoteur / responsable',val('sponsor')],['Centre principal',val('mainCenter')],['Investigateur principal',val('pi')],['Service / unité',val('piDepartment')],['Co-investigateurs',val('coInvestigators')],['Centres participants',val('participatingCenters')],['Version',val('version')],['Date',val('date')],['Qualification envisagée',val('studyType')]
      ]],
      ['2. Contexte scientifique et bibliographie',[
        ['Question / résumé du projet',val('projectQuestion')],['Contexte scientifique',val('background')],['Justification de l’étude',val('rationale')],['Synthèse bibliographique',val('literatureSynthesis')],['Références bibliographiques',refsText()]
      ]],
      ['3. Objectifs et critères de jugement',[
        ['Objectif principal',val('primaryObjective')],['Critère de jugement principal',val('primaryEndpoint')],['Objectifs secondaires',val('secondaryObjectives')],['Critères secondaires',val('secondaryEndpoints')],['Objectifs exploratoires',val('exploratoryObjectives')]
      ]],
      ['4. Méthodologie',[
        ['Design',val('design')],['Organisation',val('centers')],['Groupes / bras',val('arms')],['Randomisation',val('randomization')],['Insu',val('blinding')],['Durée totale',val('duration')],['Description méthodologique',val('methods')]
      ]],
      ['5. Population et critères d’éligibilité',[
        ['Population cible',val('population')],['Tranche d’âge',val('ageRange')],['Nombre prévu de participants',val('sampleSize')],['Critères d’inclusion',val('inclusion')],['Critères de non-inclusion / exclusion',val('exclusion')],['Mode de recrutement',val('recruitment')],['Critères de sortie prématurée',val('withdrawalCriteria')]
      ]],
      ['6. Variables, déroulement et visites',[
        ['Variables recueillies',variablesText()],['Procédures / actes / évaluations',val('procedures')],['Calendrier des visites',val('visits')],['Durée de participation',val('participantDuration')],['Sortie d’étude',val('withdrawal')]
      ]],
      ['7. Analyse statistique',[
        ['Hypothèse principale',val('hypothesis')],['Justification de la taille d’échantillon',val('sampleSizeJustification')],['Population d’analyse',val('analysisPopulation')],['Analyse principale',val('primaryAnalysis')],['Analyses secondaires',val('secondaryAnalysis')],['Ajustements / facteurs de confusion',val('adjustments')],['Données manquantes',val('missingData')],['Logiciel statistique',val('statsSoftware')]
      ]],
      ['8. Données, monitoring et qualité',[
        ['Sources de données',val('dataSources')],['Collecte / CRF / eCRF',val('dataCollection')],['Pseudonymisation',val('pseudonymisation')],['Monitoring / contrôle qualité',val('monitoring')],['Déviations et CAPA',val('capa')],['Gestion de la base',val('databaseManagement')],['Archivage',val('archiving')]
      ]],
      ['9. Éthique, RGPD, réglementaire et sécurité',[
        ['Information / consentement / non-opposition',val('consent')],['Protection des données / RGPD',val('privacy')],['Durée de conservation',val('dataRetention')],['Soumissions / autorisations',val('regulatory')],['Analyse bénéfices-risques',val('riskBenefit')],['Vigilance / événements indésirables',val('safety')],['Assurance / indemnisation',val('insurance')]
      ]]
    ];
  }

  function isList(title,content){return content&&content.indexOf('\n')>=0&&/Critères|Objectifs secondaires|Références|Co-investigateurs|Centres participants|Variables recueillies|Calendrier/.test(title)}
  function renderPreview(){
    var box=document.getElementById('ProtocolPreview'); var html='<h1>'+esc(val('title')||'Protocole de recherche clinique')+'</h1><p class="meta">'+esc([val('acronym'),val('version'),val('date')].filter(Boolean).join(' · '))+'</p>';
    protocolSections().forEach(sec=>{html+='<h2>'+esc(sec[0])+'</h2>';sec[1].forEach(item=>{html+='<h3>'+esc(item[0])+'</h3>';var c=item[1]||'À compléter.';html+=isList(item[0],c)?'<ul>'+c.split(/\n+/).filter(Boolean).map(x=>'<li>'+esc(x.trim())+'</li>').join('')+'</ul>':'<p>'+esc(c)+'</p>';});}); box.innerHTML=html;
  }
  document.getElementById('RefreshPreview').addEventListener('click',renderPreview);

  function safeFileName(){return (val('acronym')||val('title')||'protocole-recherche-clinique').replace(/[^\w\-]+/g,'_').replace(/^_+|_+$/g,'').slice(0,80);}
  async function downloadDocx(){
    renderPreview();
    if(window.docx&&window.docx.Document){try{
      var D=window.docx,children=[];
      children.push(new D.Paragraph({text:val('title')||'Protocole de recherche clinique',heading:D.HeadingLevel.TITLE}));
      children.push(new D.Paragraph({text:[val('acronym'),val('version'),val('date')].filter(Boolean).join(' · ')}));
      protocolSections().forEach(sec=>{children.push(new D.Paragraph({text:sec[0],heading:D.HeadingLevel.HEADING_1}));sec[1].forEach(item=>{children.push(new D.Paragraph({text:item[0],heading:D.HeadingLevel.HEADING_2}));var c=item[1]||'À compléter.';if(isList(item[0],c)){c.split(/\n+/).filter(Boolean).forEach(x=>children.push(new D.Paragraph({text:x.trim(),bullet:{level:0}})));}else children.push(new D.Paragraph({text:c}));});});
      children.push(new D.Paragraph({text:'Document généré avec l’assistant Arc Académie. Relecture et validation experte nécessaires avant toute utilisation réglementaire.',heading:D.HeadingLevel.HEADING_2}));
      var doc=new D.Document({sections:[{properties:{},children}]}); var blob=await D.Packer.toBlob(doc);var a=document.createElement('a');a.href=URL.createObjectURL(blob);a.download=safeFileName()+'.docx';a.click();setTimeout(()=>URL.revokeObjectURL(a.href),1500);return;
    }catch(e){}}
    var content='<!doctype html><html><head><meta charset="utf-8"></head><body>'+document.getElementById('ProtocolPreview').innerHTML+'</body></html>';var blob=new Blob(['\ufeff',content],{type:'application/msword'});var a=document.createElement('a');a.href=URL.createObjectURL(blob);a.download=safeFileName()+'.doc';a.click();
  }
  document.getElementById('DownloadDocx').addEventListener('click',downloadDocx);
  document.getElementById('DownloadBackup').addEventListener('click',function(){var blob=new Blob([JSON.stringify(state,null,2)],{type:'application/json'});var a=document.createElement('a');a.href=URL.createObjectURL(blob);a.download=safeFileName()+'_brouillon.json';a.click();});
  document.getElementById('ResetProtocol').addEventListener('click',function(){if(confirm('Supprimer tout le brouillon local ?')){localStorage.removeItem(key);location.reload();}});
  showStep(state.step||0);
})();
